"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var UTExternalLink = function UTExternalLink(_ref) {
  var url = _ref.url,
      children = _ref.children,
      className = _ref.className;
  return _react["default"].createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: className
  }, children);
};

UTExternalLink.propTypes = {
  className: _propTypes.string,
  children: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  url: _propTypes.string.isRequired
};
var _default = UTExternalLink;
exports["default"] = _default;